import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Table } from "../../components";
import { useAppContext } from "../../context/state";
import { useRequest } from "../../utils";
import { useHistory } from "react-router-dom";
import utils from "../../components/toastify/toastify";
//locall
// import "./ShowComments.css";

const GetFiles = (props) => {
  let history = useHistory();

  const [
    get_files_error,
    get_files_loading,
    get_files_data,
    get_files_function,
  ] = useRequest({
    method: "post",
    url: "/get_files",
    body: {
      product_id: props.match.params.product_id,
      term_id: props.match.params.term_id,
      day_id: props.match.params.day_id,
    },
  });

  const [
    remove_file_error,
    remove_file_loading,
    remove_file_data,
    remove_file_function,
  ] = useRequest({
    method: "post",
    url: "/remove_file",
    isFunction: true,
  });

  return (
    <>
      {/* <!-- BEGIN: Content--> */}
      <div class="content-header row">
        <div class="content-header-left col-12 mb-2 mt-1">
          <div class="row breadcrumbs-top">
            <div class="col-12">
              <h5 class="content-header-title float-left pr-1">
                جدول های اطلاعاتی
              </h5>
              <div class="breadcrumb-wrapper">
                <ol class="breadcrumb p-0 mb-0">
                  <li class="breadcrumb-item">
                    <a href="index.html">
                      <i class="bx bx-home-alt"></i>
                    </a>
                  </li>
                  <li class="breadcrumb-item active">جدول اطلاعات</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content-body">
        <button
          onClick={() =>
            history.push(
              "/dashboard/addFile/" +
                props.match.params.day_id +
                "/days/" +
                props.match.params.term_id +
                "/terms/" +
                props.match.params.product_id
            )
          }
          style={{ marginTop: "1rem", marginRight: "12px" }}
          type="button"
          class="btn btn-success mr-1 mb-1 "
        >
          افزودن فایل جدید
        </button>
        {/* <div class="row">
          <div class="col-12">
            <p>
              مستندات کامل را بخوانید در
              <a href="https://datatables.net/" target="_blank">
                اینجا
              </a>
            </p>
          </div>
        </div> */}
        {get_files_data ? (
          <Table
            Thead={() => (
              <tr>
                <th className="table--title">نام فایل</th>
                <th className="table--title">نوع فایل</th>
                <th className="table--title">سایز فایل</th>

                {/* <th className="table--title">نام محصول</th>
                <th className="table--title">متن نظر</th>
                <th className="table--title">امتیاز</th>
                <th className="table--title">عملیات</th> */}
                <th className="table--title">عملیات</th>
              </tr>
            )}
            Tbody={() =>
              get_files_data.data.map((item) => (
                <tr>
                  <td>{item.title}</td>
                  <td>{item.mimetype}</td>
                  <td>{item.size}</td>
                  <td>
                    {/* <Link to={"/dashboard/commentDetails/" + item._id}> */}
                    <Link
                      to={{
                        pathname:
                          "/dashboard/editFile/" +
                          props.match.params.day_id +
                          "/days/" +
                          props.match.params.term_id +
                          "/terms/" +
                          props.match.params.product_id,
                        query: { item },
                      }}
                    >
                      <button
                        type="button"
                        class="btn btn-warning round mr-1 mb-1 btn-sm"
                      >
                        ویرایش
                      </button>
                    </Link>
                    <button
                      onClick={() => {
                        remove_file_function({
                          product_id: props.match.params.product_id,
                          term_id: props.match.params.term_id,
                          day_id: props.match.params.day_id,
                          file_id: item._id,
                        })
                          .then(() => {
                            utils.showAlert(
                              "فایل با موفقیت حذف شد.",
                              "success"
                            );
                            get_files_function().then(() => null);
                          })
                          .catch(() =>
                            utils.showAlert("خطایی به وجود آمد", "error")
                          );
                      }}
                      type="button"
                      class="btn btn-danger round mr-1 mb-1 btn-sm"
                    >
                      حذف
                    </button>
                    {/* </Link> */}
                  </td>
                </tr>
              ))
            }
          />
        ) : null}
      </div>
      {/* <!-- END: Content--> */}
    </>
  );
};

export { GetFiles };
